import axios from 'axios';
import http from '../utils/http';
import i18n from '@/main';

const baseUrl = '/rastreabilidade/transferencia-titularidade';

export default {
    async uploadSpreadsheet(file, idEmpresaDestino) {
        const formData = new FormData();
        formData.append('idEmpresaDestino', idEmpresaDestino);
        formData.append('file', file);
        const url = process.env.VUE_APP_HTTP_PATH + baseUrl + '/inserir-lote';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    aprovarReprovar(body) {
        return http.put({
            url: baseUrl + '/aprovar-reprovar',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoEmpresas'),
            data: body
        });
    },
    async importarResultadosAprovacaoMassa(file) {
        const formData = new FormData();
        formData.append('file', file);
        const url = process.env.VUE_APP_HTTP_PATH + baseUrl + '/importar-resultados-aprovacao-massa';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${sessionStorage.getItem('jwtToken')}`
            }
        });
    }
};
